"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.IconContainer = exports.CollapsibleContainerHeader = exports.Children = void 0;

var _styledComponents = _interopRequireWildcard(require("styled-components"));

var _coreInteraction = _interopRequireDefault(require("@vfuk/core-interaction"));

var _coreMixins = require("@vfuk/core-mixins");

var _CollapsibleContainer = _interopRequireDefault(require("../../../themes/CollapsibleContainer.theme"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

var CollapsibleContainerHeader = (0, _styledComponents["default"])(_coreInteraction["default"]).withConfig({
  displayName: "CollapsibleContainerHeaderstyle__CollapsibleContainerHeader",
  componentId: "sc-1swxocl-0"
})(function (props) {
  var localTheme = (0, _CollapsibleContainer["default"])(props.theme);
  return (0, _styledComponents.css)(["width:", ";display:flex;justify-content:flex-start;align-items:center;color:", ";text-align:inherit;position:relative;margin-bottom:", "px;", " ", ""], props.width === 'auto' ? 'auto' : '100%', localTheme.appearance[props.appearance].color, props.theme.spacing.responsive[1].sm, props.size === 2 && (0, _styledComponents.css)(["font-size:", ";font-weight:", ";"], props.theme.typography.heading[1].fontDesktop, props.theme.fontWeight[3]), props.isInverse && (0, _styledComponents.css)(["color:", ";"], localTheme.appearance[props.appearance].inverse.color));
});
exports.CollapsibleContainerHeader = CollapsibleContainerHeader;

var Children = _styledComponents["default"].div.withConfig({
  displayName: "CollapsibleContainerHeaderstyle__Children",
  componentId: "sc-1swxocl-1"
})(function () {
  return (0, _styledComponents.css)(["", ";display:flex;align-items:center;justify-content:flex-start;flex:1;"], (0, _coreMixins.spacing)('margin-right', 3));
});

exports.Children = Children;

var IconContainer = _styledComponents["default"].div.withConfig({
  displayName: "CollapsibleContainerHeaderstyle__IconContainer",
  componentId: "sc-1swxocl-2"
})(function (props) {
  return (0, _styledComponents.css)(["transition:0.2s ease-out;min-height:26px;display:flex;margin-left:auto;", " span{align-items:center;}"], props.isActive && (0, _styledComponents.css)(["transform:rotate(180deg);"]));
});

exports.IconContainer = IconContainer;
//# sourceMappingURL=CollapsibleContainerHeader.style.js.map